/* IL CAPITANO — fix menu mobile overlay */
(function(){
  function update(){
    var header = document.getElementById('capHeader');
    var open = false;
    if (header) {
      open = !!header.querySelector('details[open], .menu-drawer-container[open], .menu-drawer-container.menu-opening');
    }
    document.documentElement.classList.toggle('cap-menu-open', open);
    document.body.classList.toggle('cap-menu-open', open);
  }

  function bind(){
    update();
    document.addEventListener('click', function(){ setTimeout(update, 40); }, true);
    document.addEventListener('keyup', update, true);
    document.addEventListener('keydown', update, true);

    var header = document.getElementById('capHeader');
    if (header && 'MutationObserver' in window) {
      new MutationObserver(update).observe(header, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['open', 'class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once:true });
  } else {
    bind();
  }
})();
